export interface CustomerState {
    getAllCustomerSuccess : any;
    getAllCustomerError: any;
    getAddCustomerSuccess: any;
    getAddCustomerError: any;
    importCustomerExcelSuccess: any;
    importCustomerExcelError: any;
    getEditCustomerSuccess: any;
    getEditCustomerError:any;
    getCustomerNumberSuccess: any;
    getCustomerNumberError: any;
    getDeleteCustomerSuccess: any;
    getDeleteCustomerError: any;
    getCustomerContactReviewSuccess: any;
    getCustomerContactReviewError: any;

}
export const InitialCustomerState : CustomerState = {
    getAllCustomerSuccess : null,
    getAllCustomerError:null,
    getAddCustomerSuccess: null,
    getAddCustomerError:null,
    importCustomerExcelSuccess: null,
    importCustomerExcelError: null,
    getEditCustomerSuccess:null,
    getEditCustomerError: null,
    getCustomerNumberSuccess: null,
    getCustomerNumberError: null,
    getDeleteCustomerSuccess: null,
    getDeleteCustomerError: null,
    getCustomerContactReviewSuccess: null,
    getCustomerContactReviewError: null
}
